import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { AccountUserInformationResponse } from '@app/model/api/account/AccountUserInformationResponse';
import { BaseResponse } from '@app/model/api/BaseResponse';
import { tap } from 'lodash';
import { mode } from 'crypto-js';




@Injectable({
  providedIn: 'root',
})

export class GetService {
  constructor(private http: HttpClient) { }




  public getImage(paramInput: HttpParams, url: string): Observable<any> {
    const options = {
      params: paramInput,
      withCredentials: true,
      mode: 'no-cors',

      headers: new HttpHeaders({
        'Accept': 'image/png',
        // 'Content-Type': ' charset=utf-8'
      })
    };

    return this.http.get(
      url,
      options
    )
      .pipe(
        catchError(this.handleError<any>('GET')));
  }

  public get(paramInput: HttpParams, url: string): Observable<any> {
    const options = {
      params: paramInput,
      withCredentials: true,
      headers: new HttpHeaders({
        'Accept': 'application/json, text/javascript, */*;',
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
      })
    };

    return this.http.get(
      url,
      options
    )
      .pipe(
        catchError(this.handleError<any>('GET')));
  }


  /**
    * Handle Http operation that failed.
    * Let the app continue.
    *
    * @param operation - name of the operation that failed
    * @param result - optional value to return as the observable result
    */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(`${operation} failed: ${error.message} ${error.status}`); // log to console instead

      // If 403 then send to login
      if (error.status === 403) {
        //   window.location.href = '/login';
        // code 1 is unauthorized:
        console.log("Creating new status object 403");
        let response = new BaseResponse();
        response.status = { code: 1, codes: [], message: "Unauthorized" };
        return of(response as T);
      }

      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);

      if (error.status === 424) {
        // A 424 is set when the user must enter an MFA code
        let response = new BaseResponse();
        response.status = { code: 99, codes: [], message: "MFA Required" };

        return of(response as T);
      } else {
        // Let the app keep running by returning an empty result.

        return of(result as T);
      }
    };
  }

}
